"use strict";

var _interopRequireDefault = require("/Volumes/Untitled/project/185/185admin/node_modules/@babel/runtime/helpers/interopRequireDefault.js").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es.array.concat.js");
require("core-js/modules/es.object.to-string.js");
var _regeneratorRuntime2 = _interopRequireDefault(require("/Volumes/Untitled/project/185/185admin/node_modules/@babel/runtime/helpers/regeneratorRuntime.js"));
var _asyncToGenerator2 = _interopRequireDefault(require("/Volumes/Untitled/project/185/185admin/node_modules/@babel/runtime/helpers/asyncToGenerator.js"));
var _classCallCheck2 = _interopRequireDefault(require("/Volumes/Untitled/project/185/185admin/node_modules/@babel/runtime/helpers/classCallCheck.js"));
var _createClass2 = _interopRequireDefault(require("/Volumes/Untitled/project/185/185admin/node_modules/@babel/runtime/helpers/createClass.js"));
var _callSuper2 = _interopRequireDefault(require("/Volumes/Untitled/project/185/185admin/node_modules/@babel/runtime/helpers/callSuper.js"));
var _inherits2 = _interopRequireDefault(require("/Volumes/Untitled/project/185/185admin/node_modules/@babel/runtime/helpers/inherits.js"));
var _defineProperty2 = _interopRequireDefault(require("/Volumes/Untitled/project/185/185admin/node_modules/@babel/runtime/helpers/defineProperty.js"));
var _tslib = require("tslib");
var _vuePropertyDecorator = require("vue-property-decorator");
var _index = _interopRequireDefault(require("@/components/Pagination/index.vue"));
var _enum = require("@/utils/enum");
var _returnOrder = require("@/api/returnOrder.api");
var _OrderModal = _interopRequireDefault(require("./components/OrderModal.vue"));
var _returnOrder2 = require("@/types/return-order");
var RefundConsignTable = /*#__PURE__*/function (_Vue) {
  function RefundConsignTable() {
    var _this;
    (0, _classCallCheck2.default)(this, RefundConsignTable);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = (0, _callSuper2.default)(this, RefundConsignTable, [].concat(args));
    (0, _defineProperty2.default)(_this, "type", void 0);
    (0, _defineProperty2.default)(_this, "data", []);
    (0, _defineProperty2.default)(_this, "total", 0);
    (0, _defineProperty2.default)(_this, "listLoading", false);
    (0, _defineProperty2.default)(_this, "query", {
      page: 1,
      limit: 12,
      search: null,
      type: ""
    });
    (0, _defineProperty2.default)(_this, "tagOptions", _enum.tagOptions);
    (0, _defineProperty2.default)(_this, "ReturnOrderType", _returnOrder2.ReturnOrderType);
    (0, _defineProperty2.default)(_this, "$refs", void 0);
    return _this;
  }
  (0, _inherits2.default)(RefundConsignTable, _Vue);
  return (0, _createClass2.default)(RefundConsignTable, [{
    key: "handleCreate",
    value: function () {
      var _handleCreate = (0, _asyncToGenerator2.default)( /*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee() {
        return (0, _regeneratorRuntime2.default)().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              this.$refs.modal.handleCreate(this.type);
            case 1:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function handleCreate() {
        return _handleCreate.apply(this, arguments);
      }
      return handleCreate;
    }()
  }, {
    key: "handleUpdate",
    value: function handleUpdate(row) {
      this.$refs.modal.handleUpdate(row);
    }
  }, {
    key: "created",
    value: function created() {
      this.query.type = this.type;
      this.fetchData();
    }
  }, {
    key: "fetchData",
    value: function fetchData() {
      var _this2 = this;
      this.listLoading = true;
      _returnOrder.returnOrderApi.findAll(this.query).then(function (res) {
        _this2.data = res.data.returnOrders;
        _this2.total = res.data.total;
      }).finally(function () {
        return _this2.listLoading = false;
      });
    }
  }]);
}(_vuePropertyDecorator.Vue);
(0, _tslib.__decorate)([(0, _vuePropertyDecorator.Prop)()], RefundConsignTable.prototype, "type", void 0);
RefundConsignTable = (0, _tslib.__decorate)([(0, _vuePropertyDecorator.Component)({
  components: {
    Pagination: _index.default,
    OrderModal: _OrderModal.default
  }
})], RefundConsignTable);
var _default = exports.default = RefundConsignTable;